module.exports = __webpack_public_path__ + "img/weixin.c9b3a8df.png";